import { FC } from 'react';

interface ErrorMsgProps {
    message?: string;
    className?: string;
}
export const ErrorMessage: FC<ErrorMsgProps> = ({ message, className }) => {
    return message ? <h6 className={`text-danger ${className ?? 'text-center'}`}>{message}</h6> : null;
};
